<div class="card mt-2" *ngIf="description">
	<div class="card-body">
		<h5 class="card-title">Description</h5>
		<!-- Editor -->
		<app-text-viewer name="viewer" [ngModel]="description" #viewer="ngModel"></app-text-viewer>
	</div>
</div>